import { convexQuery, useConvexMutation } from "@convex-dev/react-query";
import { useMutation, useQuery } from "@tanstack/react-query";
import type { Id } from "@teachloop/backend/_generated/dataModel";
import { useRouter } from "expo-router";
import React, { Fragment } from "react";
import { Text, View } from "react-native";
import TutorBookingCard from "../shared/tutor-booking-card";
import { api } from "../utils/convex-api";

function TutorBookings() {
  const { data: pendingBookings } = useQuery({
    ...convexQuery(api.tutor.home.queries.getPendingBookings, {}),
  });
  const safePendingBookings = pendingBookings ?? [];

  const { mutateAsync: declineBooking } = useMutation({
    mutationFn: useConvexMutation(
      api.tutor.reviewLesson.mutations.declineBooking,
    ),
  });

  const router = useRouter();

  const onReview = (bookingId: Id<"bookings">) => {
    router.push(`/booking/review-request?bookingId=${bookingId}`);
  };

  const onDecline = (bookingId: Id<"bookings">, reason?: string) => {
    if (reason) {
      declineBooking({
        bookingId,
        declinedReason: reason,
      });
    }
  };

  return (
    <Fragment>
      {safePendingBookings.length > 0 && (
        <View className="gap-4">
          <Text className="font-geologica-medium font-medium text-[16px] text-gray-800 leading-[1.2]">
            {safePendingBookings.length} pending request
            {safePendingBookings.length > 1 ? "s" : ""}
          </Text>

          {safePendingBookings.map((booking) => (
            <TutorBookingCard
              key={booking.bookingId}
              booking={booking}
              onReview={() => onReview(booking.bookingId)}
              onDecline={(reason) => onDecline(booking.bookingId, reason)}
            />
          ))}
        </View>
      )}
    </Fragment>
  );
}

export default TutorBookings;
